import React, { useState } from 'react'

import RecommendedSellerInfoModal from '@components/RecommendedSellerInfoModal'

const useRecommendedSellerInfoModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleModalOpen = () => {
    setIsOpen(!isOpen)
  }

  return {
    RecommendedSellerInfoModal: () => <RecommendedSellerInfoModal isOpen={isOpen} onClose={toggleModalOpen} />,
    toggleModalOpen
  }
}

export default useRecommendedSellerInfoModal
